import React from "react";

const GettingStarted = () => {
  return <h1>getting started</h1>;
};

export default GettingStarted;
